import Vue from 'vue'
import VueRouter from 'vue-router'

import { routerGuards, prepRoute } from '@/services/routerGuards'

import { authRoutes, authRoutesGuard } from '@/../GjirafaFront/script/auth'

import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from '@/store'

// Our routes
import profile from './routes/profile'
import captain from './routes/captain'
import cdn from './routes/cdn'
import encoder from './routes/encoder'
import storage from './routes/storage'
import security from './routes/security'
import pages from './routes/pages'
import errorPages from './routes/errorPages'
import observability from './routes/observability'
// import databases from './routes/databases'
// import compute from './routes/compute'
// import kyubi from './routes/kyubi'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: { name: 'distributions' },
    },
    ...authRoutes,
    ...cdn,
    ...captain,
    ...encoder,
    ...storage,
    ...security,
    ...errorPages,
    ...pages,
    ...profile,
    ...observability,
    // ...databases,
    // ...compute,
    // ...kyubi,
    { path: '/:projectId?', redirect: { name: 'distributions' } },
    ...(process.env.NODE_ENV === 'development'
      ? [
        {
          path: '/:projectId/gj/icons',
          name: 'gj-icons',
          component: () => import('@/views/pages/GjirafaIcons.vue'),
        },
      ]
      : []),
    {
      path: '/login',
      name: 'auth-login',
      component: () => import('@/views/pages/auth/Login.vue'),
      meta: {
        isPublic: true,
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

prepRoute(router)
authRoutesGuard(router)
routerGuards(router)

router.beforeEach((to, from, next) => {
  vuexOidcCreateRouterMiddleware(store, 'oidcStore')
  next()
})

export default router
